var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as types from './types';
import * as statuses from '../../states';
var initialState = {
    importedAccounts: {
        status: statuses.IDLE,
        issuers: [],
        importIds: {
            status: statuses.IDLE,
            list: [],
        },
    },
    contacts: {
        status: statuses.IDLE,
        blacklist: false,
        validation: statuses.IDLE,
        isValidationAuthorized: false,
    },
    typeAccount: {
        isOpen: false,
        source: null,
        label: null,
    },
    addAccount: {
        isOpen: false,
        status: statuses.IDLE,
        account: null,
    },
    uploadContacts: {
        progress: 0,
        status: statuses.IDLE,
    },
};
function isArrayofStrings(obj) {
    return Array.isArray(obj) && obj.every(function (element) { return typeof element === 'string'; });
}
export default function importContactReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.FETCH_IMPORTED_ACCOUNTS_REQUEST:
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { status: (state.importedAccounts.status === statuses.IDLE)
                        ? statuses.LOADING
                        : state.importedAccounts.status }) });
        case types.FETCH_IMPORTED_ACCOUNTS_SUCCEEDED:
            if (!payload || !(typeof payload === 'object') || !('issuers' in payload))
                return;
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { status: statuses.SUCCESS, issuers: payload.issuers }) });
        case types.FETCH_IMPORTED_ACCOUNTS_FAILED:
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { status: statuses.FAIL }) });
        case types.GET_IMPORT_IDS_REQUEST:
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { importIds: __assign(__assign({}, state.importedAccounts.importIds), { status: statuses.LOADING }) }) });
        case types.GET_IMPORT_IDS_SUCCEEDED:
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { importIds: __assign(__assign({}, state.importedAccounts.importIds), { status: statuses.SUCCESS, list: payload }) }) });
        case types.GET_IMPORT_IDS_FAILED:
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { importIds: __assign(__assign({}, state.importedAccounts.importIds), { status: statuses.FAIL }) }) });
        case types.ADD_BLACKLIST_REQUEST:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { blacklist: true }) });
        case types.ADD_BLACKLIST_SUCCEEDED:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { blacklist: false }) });
        case types.ADD_BLACKLIST_FAILED:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { blacklist: false, error: payload }) });
        case types.REMOVE_BLACKLIST_REQUEST:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { blacklist: true }) });
        case types.REMOVE_BLACKLIST_SUCCEEDED:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { blacklist: false }) });
        case types.REMOVE_BLACKLIST_FAILED:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { blacklist: false, error: payload }) });
        case types.OPEN_ADD_ACCOUNT:
            if (!payload || typeof payload !== 'object' || !('formType' in payload))
                return;
            return __assign(__assign({}, state), { addAccount: __assign(__assign({}, state.addAccount), { status: statuses.IDLE, isOpen: !state.addAccount.isOpen, account: __assign(__assign({ host: '', mail: '', password: '', error: null }, payload), { id: payload === null || payload === void 0 ? void 0 : payload.mail }) }) });
        case types.OPEN_SET_LABEL:
            return __assign(__assign({}, state), { typeAccount: {
                    isOpen: !state.typeAccount.isOpen,
                    source: payload,
                    label: null,
                } });
        case types.SET_LABEL:
            return __assign(__assign({}, state), { typeAccount: {
                    isOpen: false,
                    label: payload,
                } });
        case types.ADD_ACCOUNT_REQUEST:
            return __assign(__assign({}, state), { addAccount: __assign(__assign({}, state.addAccount), { status: statuses.LOADING }) });
        case types.ADD_ACCOUNT_SUCCEEDED:
            if (!payload || typeof payload !== 'object' || !('import_id' in payload))
                return;
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { issuers: __spreadArray(__spreadArray([], state.importedAccounts.issuers
                        .filter(function (issuer) { return issuer.import_id !== payload.import_id; }), true), [
                        __assign(__assign({}, payload), { status: 'wait', msg: 'wait' }),
                    ], false) }), addAccount: __assign(__assign({}, state.addAccount), { status: statuses.SUCCESS }) });
        case types.ADD_ACCOUNT_WEBMAIL_REQUEST:
            return __assign(__assign({}, state), { addAccount: __assign({}, state.addAccount) });
        case types.ADD_ACCOUNT_FAILED:
            return __assign(__assign({}, state), { addAccount: __assign(__assign({}, state.addAccount), { status: statuses.FAIL, error: payload }) });
        case types.VERIFY_ACCOUNT_TOKEN_REQUEST:
            return __assign(__assign({}, state), { addAccount: __assign(__assign({}, state.addAccount), { status: statuses.LOADING }) });
        case types.VERIFY_ACCOUNT_TOKEN_SUCCEEDED:
            return __assign(__assign({}, state), { addAccount: __assign(__assign({}, state.addAccount), { status: statuses.SUCCESS }) });
        case types.VERIFY_ACCOUNT_TOKEN_FAILED:
            return __assign(__assign({}, state), { addAccount: __assign(__assign({}, state.addAccount), { status: statuses.FAIL, error: payload }) });
        case types.SET_UPLOAD_PROGRESS:
            return __assign(__assign({}, state), { uploadContacts: __assign(__assign({}, state.uploadContacts), { progress: payload }) });
        case types.UPLOAD_CONTACTS_REQUEST:
            return __assign(__assign({}, state), { uploadContacts: __assign(__assign({}, state.uploadContacts), { status: statuses.LOADING }) });
        case types.UPLOAD_CONTACTS_SUCCEEDED:
            if (!payload || !(typeof payload === 'object'))
                return;
            return __assign(__assign({}, state), { importedAccounts: __assign(__assign({}, state.importedAccounts), { issuers: __spreadArray(__spreadArray([], state.importedAccounts.issuers, true), [
                        __assign({ status: 'wait', msg: 'wait' }, payload),
                    ], false) }), uploadContacts: {
                    progress: 100,
                    status: statuses.SUCCESS,
                } });
        case types.UPLOAD_CONTACTS_FAILED:
            return __assign(__assign({}, state), { uploadContacts: {
                    progress: 0,
                    status: statuses.FAIL,
                } });
        case types.RESET_UPLOAD_FILE:
            return __assign(__assign({}, state), { uploadContacts: {
                    progress: 0,
                    status: statuses.IDLE,
                } });
        case types.VALIDATE_CONTACTS_LIST_REQUEST:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { validation: statuses.IDLE }) });
        case types.VALIDATE_CONTACTS_LIST_SUCCEEDED:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { validation: statuses.SUCCESS }) });
        case types.VALIDATE_CONTACTS_LIST_FAILED:
            return __assign(__assign({}, state), { contacts: __assign(__assign({}, state.contacts), { validation: statuses.FAIL }) });
        default:
            return state;
    }
}
